import React from "react";

import PropTypes from 'prop-types';
import vineyard from './../../Home/assets/images/slide_02.jpg'
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Header from './Header';
import MainFeaturedPost from './MainFeaturedPost';
import FeaturedPost from './FeaturedPost';
import Footer from './Footer';
import winter from './../../Styles/images/winter.jpg';
import pumpkin from './../../Styles/images/pumpkin.jpg';

const sections = [
    { title: 'Events', url: '#' },
    { title: 'Wines', url: '#' },
    { title: 'About', url: '#' },
    { title: 'Community', url: '#' },
    { title: 'Locations', url: '#' },
    { title: 'Memberships', url: '#' },
  
  ];
  
  const mainFeaturedPost = {
    title: 'Support Local Vineyards',
    description:
      "At Paige's Vines, we are on a mission to bring you the best wines from our Willamette Valley winery.",
    image: vineyard,
    imageText: 'main image description',
    linkText: 'Book a Tasting Now',
  };
  
  const featuredPosts = [
    {
      title: 'Harvest Party',
      date: 'October 12',
      description:
        'Join us in cellabrating this seasons exceptional harvest! Enjoy wine, pumpkin sculptures, harvest themed treats, and exceptional fall vineyard scenery',
      image: pumpkin,
      imageLabel: 'Image Text',
    },
    {
      title: 'Holiday Party',
      date: 'December 11',
      description:
        'Wrap up the year with us in the Barrel Room- wine, bites, and prizes. This event fills quickly so make sure to book in advance.',
      image: winter,
      imageLabel: 'Image Text',
    },
  ];
const WinerySampleComponent = props => {

    return(
   <>
       <Container maxWidth="lg">
            <Header title="Paige's Vines" sections={sections} tab={props.tab} updateTab={props.updateTab} />
            <main>
                <MainFeaturedPost post={mainFeaturedPost} />
                <Grid container spacing={4}>
                    {featuredPosts.map((post) => (
                        <FeaturedPost key={post.title} post={post} />
                        ))}
                </Grid>
        
            </main>
        </Container>
        <Footer
        title="Footer"
        description="Our hypothetical grapes are sourced and grown in the Willamette Valley for our make-belive vinyard!"
        />
    </>
    );
}

WinerySampleComponent.defaultProps = {

}
WinerySampleComponent.propTypes = {
    tab: PropTypes.string,
    updateTab:PropTypes.func,
}

export default (WinerySampleComponent);
